export default function upperFirst<T extends string>(s: T): Capitalize<T> {
  return (s.slice(0, 1).toUpperCase() + s.slice(1)) as Capitalize<T>
}
